export default __webpack_public_path__ + "static/media/plus.eed54d3e.svg";